import request from '../request';

export default {
  // 频道-列表
  list(data) {
    return request.get('/AdminCityPlate/index', data);
  },

  // 频道-添加
  add(data) {
    return request.post('/AdminCityPlate/create', data);
  },

  // 频道-编辑
  edit(data) {
    return request.post('/AdminCityPlate/edit', data);
  },

  // 频道-删除
  delete(data) {
    return request.post('/AdminCityPlate/delete', data);
  },

  // 频道-内容-可关联列表
  resource(data) {
    return request.get('/AdminCityPlateResource/resource', data);
  },

  // 频道-内容-已关联
  listContent(data) {
    return request.get('/AdminCityPlateResource/list', data);
  },

  // 频道-内容-更新推荐
  recommend(data) {
    return request.post('/AdminCityPlateResource/recommend', data);
  },

  // 频道-内容-关联
  addRelate(data) {
    return request.post('/AdminCityPlateResource/relate', data);
  },

  // 频道-内容-取消关联
  deleteRelate(data) {
    return request.post('/AdminCityPlateResource/delete', data);
  },

  // 频道-内容-排序
  sort(data) {
    return request.post('/AdminCityPlateResource/sort', data);
  },
};
